<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '利息收入明细表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <!-- -->

      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :sort.sync="sort"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">收入合计：{{(totalAmounts/10000).toFixed(2)||''}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">笔数合计：{{listData.count}}</div></el-col>
        </div>
      </data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery,xmlBuildSort} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "InterestRevenueList",
    data() {
      return {
        sort: {
          fields: ['fi__transactionNo', 'rex__repayDate'],
          default: {
            prop: 'fi__transactionNo',
            order: 'ascending'
          },
          params: {}
        },
        page: 1,
        pageSize: 20,
        listData: {},
        totalAmounts:0,
        balanceAmounts:0,
        listColumns: [
          {
            name: '序号',
            field: 'fi__index'
          },
            {
                name: '贷款编号',
                field: 'fi__transactionNo'
            },
          {
            name: '客户姓名',
            field: 'fi__customerName'
          },
          {
            name: '渠道商',
            field: 'd__dealerName'
          },
          {
            name: '放款金额',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return ''
            }
          },
          {
            name: '期数',
            field: 'plan__sequenceNo',
          },

          {
            name: '实还款日',
            field: 'rex__repayDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '利息收入',
            field: 'rex__interestAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '罚息/复利',
            field: 'rex__interestAmountII',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '利息收入（不含税）',
            field: '-1-',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return formatMoney(r.rex__interestAmount/(1+parseFloat(r.vat__taxRate)))
            }
          },
          {
            name: '实收增值税',
            field: '-2-',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return formatMoney(r.rex__interestAmount*parseFloat(r.vat__taxRate)/(1+parseFloat(r.vat__taxRate)))
            }
          },
          {
            name: '罚息/复利收入（不含税）',
            field: '-3-',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return formatMoney(r.rex__interestAmountII/(1+parseFloat(r.vat__taxRate)))
            }
          },
          {
            name: '实收增值税',
            field: '-4-',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return formatMoney(r.rex__interestAmountII*parseFloat(r.vat__taxRate)/(1+parseFloat(r.vat__taxRate)))
            }
          },
          {
            name: '交易类型',
            field: 'resolve__automatic',
            formatter: function (r,c,v) {
                if(v)
              return Status2CN('InterestRevenueList_'+v)
                else
              return ''
            }
          },
        ],
        filters: {
          form: {
            rex__repayDate: [],
            fi__customerName:'',
            d__dealerId:'',
          },
          rules: {
            rex__repayDate:{
              required:true,
              message: '不能为空'
            }
          },
          columns: [
            {
              label: '实还款日',
              component: 'date-range-picker',
              field: 'rex__repayDate',
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'fi__customerName',
            },
            {
              label: '渠道商',
              component: 'el-select',
              field: 'd__dealerId',
              options:[],
              span: 12
            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          },
          onReset: ()=> {
            this.filters.form = {
              rex__repayDate: [],
              fi__customerName:'',
              d__dealerId:'',
            }
            this.listData= {
              count: 0,
              data: []
            }
            this.totalAmounts = 0

          }
        },
        actions: [
          {
            label: '导出',
            clickHandler:()=>{
                if(this.filters.form.rex__repayDate.length==0){
                    this.$message.error('请填写实还款日')
                    return false
                }
              let routeData = this.$router.resolve({
                path: '/ix/fang/financing/reporting/InterestRevenue.List?format=xls',
                query: Object.assign({
                  pageSize:0,
                  frDate:this.filters.form.rex__repayDate[0]||'1900-12-31 00:00:00',
                  'frDate.dateformat':'yyyy-MM-dd',
                  toDate:this.filters.form.rex__repayDate[1]||'2099-12-31 00:00:00',
                  'toDate.dateformat':'yyyy-MM-dd',
                }, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ],
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            /* pageSize: this.pageSize,
             pageOffset: (this.page - 1) * this.pageSize,*/
            /* 'xlist.sort.dataField': 'fi.transactionDate',
             'xlist.sort.order': 'desc'*/
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getData()
      },
      sort: function () {
        this.getData()
      }
    },
    mounted() {
      //this.getData()
      this.getDealerList()
    },
    methods: {
      getData: function () {
        xhr.getInterestRevenueList(
          Object.assign({
            pageSize:0,
            frDate:this.filters.form.rex__repayDate[0]||'1900-12-31 00:00:00',
            'frDate.dateformat':'yyyy-MM-dd',
            toDate:this.filters.form.rex__repayDate[1]||'2099-12-31 00:00:00',
            'toDate.dateformat':'yyyy-MM-dd',
          }, this.filterParams, xmlBuildQuery(this.filters),xmlBuildSort(this.sort.params)),
          res=> {
            try {
                let interestAmounts = 0
                let interestAmountIIs = 0
                let num1 = 0
                let num2 = 0
                let num3 = 0
                let num4 = 0

              this.totalAmounts= 0
              this.listData = res.data
              this.listData.data.forEach(item=>{
                this.totalAmounts = this.totalAmounts +(parseFloat(item.rex__interestAmount)/(1+parseFloat(item.vat__taxRate))+parseFloat(item.rex__interestAmount)*parseFloat(item.vat__taxRate)/(1+parseFloat(item.vat__taxRate))
                  +parseFloat(item.rex__interestAmountII)/(1+parseFloat(item.vat__taxRate))+parseFloat(item.rex__interestAmountII)*parseFloat(item.vat__taxRate)/(1+parseFloat(item.vat__taxRate)))*10000

                  if(item.rex__interestAmount){
                      interestAmounts = interestAmounts +parseFloat(item.rex__interestAmount)*10000
                  }

                  if(item.rex__interestAmountII){
                      interestAmountIIs = interestAmountIIs +parseFloat(item.rex__interestAmountII)*10000
                  }
                  num1 = num1 +item.rex__interestAmount/(1+parseFloat(item.vat__taxRate))*10000
                  num2 = num2 +item.rex__interestAmount*parseFloat(item.vat__taxRate)/(1+parseFloat(item.vat__taxRate))*10000
                  num3 = num3 +item.rex__interestAmountII/(1+parseFloat(item.vat__taxRate))*10000
                  num4 = num4 +item.rex__interestAmountII*parseFloat(item.vat__taxRate)/(1+parseFloat(item.vat__taxRate))*10000
              })
                this.listData.data.push({
                    fi__customerName:'合计',
                    rex__interestAmount:(interestAmounts/10000).toFixed(2)||'',
                    rex__interestAmountII:(interestAmountIIs/10000).toFixed(2)||'',
                    '-1-':(num1/10000).toFixed(2)||'',
                    '-2-':(num2/10000).toFixed(2)||'',
                    '-3-':(num3/10000).toFixed(2)||'',
                    '-4-':(num4/10000).toFixed(2)||'',

                })
            }catch(e){

            }
          })

      },
      getDealerList: function () {
        xhr.getDealerList(
          Object.assign({pageSize:0}, {}, {}),
          res=> {
            try {
              /*this.filters.columns[2].options = [
                {
                  label: '所有渠道商',
                  value: ''
                }
              ].concat(res.data.data.map(item=>{
                return {
                  label: item.d__dealerName,
                  value:item.d__dealerId,
                }
              }))*/
              this.filters.columns[2].options = res.data.data.map(item=>{
                return {
                  label: item.d__dealerName,
                  value:item.d__dealerId,
                }
              })
            }catch(e){

            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/InterestRevenueList.vue